import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { BiMinusCircle } from "react-icons/bi";
//date picker
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useMutation } from "@apollo/client";

import { AuthContext } from "../../Context/AuthContext";
import { SelectOffice, SelectWarehouse } from "../Include/DynamicSelect";
import ListReqTakeOut from "./ListReqTakeOut";
import { RECIEVE_TAKE_OUT } from "../../Schema/TakeOut";

export default function RecieveTakeOut({
  open,
  editData,
  handleClose,
  setRefetch,
  dialogTitle,
}) {
//   console.log("EEEEE", editData);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selectOffice, setSelectedOffice] = useState({ id: "", title: "" });
  const [selectWarehouseVal, setSelectedWarehouseVal] = useState({
    id: "",
    title: "",
  });
  const [submitStutus, setSubmitStatus] = useState("");
  const [requireField, setRequireField] = useState(false);
  const listReqTakeOutMaterial = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    qty: 0,
    key: Date.now() + Math.random(),
  };
  const [listTakeOutData, setListTakeOutData] = useState([
    listReqTakeOutMaterial,
  ]);
  // console.log("submitStutus", submitStutus);
  const handleAddReqTakeOut = () => {
    setListTakeOutData([...listTakeOutData, listReqTakeOutMaterial]);
  };
  const handleUpdateReqTakeOut = (key, val, fieldName) => {
    const newListTakeOutData = listTakeOutData?.map((d) => {
      if (val === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = val;
        }
        if (key === d.key && fieldName === "listMaterialUnitId")
          d.listMaterialUnitId = val;
        if (key === d.key && fieldName === "qty") d.qty = val;
      }
      return d;
    });
    setListTakeOutData(newListTakeOutData);
  };
  const handleDeleteListReqTakeOut = (key) => {
    const handleDeleteList = listTakeOutData?.filter((d) => d.key !== key);
    setListTakeOutData([...handleDeleteList]);
  };

  //receiveTakeOutMaterial
  const [receiveTakeOutMaterial] = useMutation(RECIEVE_TAKE_OUT, {
    onCompleted: ({ receiveTakeOutMaterial }) => {;
      setLoading(false);
      if (receiveTakeOutMaterial?.status) {
        setAlert(true, "success", receiveTakeOutMaterial?.message);
        handleClose();
        resetForm();
        setRefetch();
        setListTakeOutData([listReqTakeOutMaterial]);

        setSelectedWarehouseVal({ id: "", title: "" });
      } else {
        setAlert(true, "error", receiveTakeOutMaterial?.message);
        console.log("error");
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log("error", error?.message);
      setAlert(true, "error", error?.message);
    },
  });
  //formik
  const CheckValidation = Yup.object().shape({
    status: Yup.string().required("ទាមទារ!"),
    // officeId: Yup.string().required("ទាមទារ!"),
    remark: Yup.string(),
  });
  const formik = useFormik({
    initialValues: {
      status: "Pending",
      remark: "",
  
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
    //   console.log("vlaues", values);
      let createStatus = false;
      const BreakException = {};
      try {
        listTakeOutData?.forEach(function (elem) {
          if (
            elem?.materialId?.id !== undefined &&
            elem?.materialId?.id !== "" &&
            elem?.listMaterialUnitId?.id !== undefined &&
            elem?.listMaterialUnitId?.id !== "" &&
            elem?.qty > 0
          ) {
            createStatus = true;
          } else {
            setLoading(false);
            setRequireField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }
      if (createStatus) {
        let listReqTakeOutMaterialToSubmit = listTakeOutData?.map((d) => {
        //   console.log("d", d);
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            qty: parseFloat(d?.qty),
          };
        });
        setLoading(true);
        // console.log(
        //   "editData?.checkTakeOutMaterial?._id",
        //   editData?.checkTakeOutMaterial
        // );
        // console.log("values?.warehouseId", values?.warehouseId);
        // console.log(
        //   "listReqTakeOutMaterialToSubmit",
        //   listReqTakeOutMaterialToSubmit
        // );
        receiveTakeOutMaterial({
          variables: {
            id: editData?._id,
            // status: submitStutus === "Approved" ? "Approved" : "Rejected",
      
            receiveTakeOutMaterial: listReqTakeOutMaterialToSubmit,
            remark: values?.remark,
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("remark", editData?.remark ?? "");
      // setSelectedOffice({
      //   id: editData?.officeId?._id,
      //   title: editData?.officeId?.officeKhName,
      // });
      // setFieldValue("officeId", selectOffice?.id);
    }

    if (editData?.deliveryTakeOutMaterial?.length !== 0) {
      const dataFromBackend = editData?.deliveryTakeOutMaterial?.map((d) => {
        console.log("d",d)
        return {
          key: Date.now() + Math.random(),
          materialId: {
            id: d?.listMaterialUnitId?.materialId?._id,
            title: d?.listMaterialUnitId?.materialId?.materialEnName,
          },
          listMaterialUnitId: {
            id: d?.listMaterialUnitId?._id,
            title: d?.listMaterialUnitId?.unitId?.unitKhName,
            imageSrc: d?.listMaterialUnitId?.imageSrc,
          },
          qty: d?.qty,
        };
      });
      // console.log("dataFromBackend::", dataFromBackend)
      setListTakeOutData([...dataFromBackend]);
    }
  }, [editData, open]);


  // useEffect(() => {
  //   if (selectOffice?.id) {
  //     setFieldValue("officeId", selectOffice?.id ?? "");
  //   }
  // }, [selectOffice?.id]);
  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">បង្កើតការទទួលទំនិញ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={4}>
                <Typography className="field-title">អ្នកតំណាងការិយាល័យ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  value={editData?.userId?.mainUserId?.firstName + ' ' + editData?.userId?.mainUserId?.lastName }
                />
              </Grid>
              <Grid item xs={4}>
                <Typography className="field-title">ឃ្លាំងទំនិញ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  value={editData?.warehouseId?.warehouseName}
                />
              </Grid>
              <Grid item xs={12}>
                <ListReqTakeOut
                  handleDeleteList={handleDeleteListReqTakeOut}
                  handleUpdateList={handleUpdateReqTakeOut}
                  handleAddList={handleAddReqTakeOut}
                  requiredField={requireField}
                  listTakeOutData={listTakeOutData}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">កំណត់សម្គាល់</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    បញ្ជាការទទួលទំនិញ
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
